import React from "react";
import Carousel from "./Carousel";
import Card2 from "./Card2";
import "./index.css";
import { FMS_MEDIA } from "../../utils/config";
import { Link } from "react-router-dom";

const OurServices = ({ carList }) => {
  return (
    <div className="container mx-auto mt-24">
      <div className="flex justify-between mx-12 md:mx-32 items-center ">
        <h1 className="text-4xl font-medium">Our Fleet</h1>
        <Link
          to={"/ourfleet"}
          className="text-base text-[var(--main-color2)] font-bold"
        >
          <p className=" flex items-end gap-4 my-12">
            More Fleet{" "}
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mb-1"
            >
              <path
                d="M12.3033 10.7794C12.0735 10.7794 11.865 10.6863 11.7141 10.5355C11.5633 10.3846 11.4701 10.1761 11.4701 9.94629L11.4701 3.70843L2.28603 12.8925C1.96017 13.2184 1.43338 13.2184 1.10752 12.8925C0.781663 12.5666 0.781663 12.0399 1.10752 11.714L10.2916 2.52992L4.05371 2.52989C3.59291 2.52989 3.22054 2.15751 3.22054 1.69671C3.22054 1.23592 3.593 0.863454 4.0538 0.863454L12.3034 0.863449C12.7642 0.863449 13.1365 1.2358 13.1365 1.6966L13.1365 9.94617C13.1365 10.407 12.7641 10.7794 12.3033 10.7794Z"
                fill="#181A1F"
              />
            </svg>
          </p>
        </Link>
      </div>
      <Carousel className="my-12" breakPoints={true}>
        {carList?.map((item, index) => (
          <Card2
            key={index}
            title={item?.displayname}
            description={item?.description}
            passengers={item.vehicles[0]?.seaterss}
            luggage={item.vehicles[0]?.luggage}
            imageSrc={`${
              item.vehicles.length > 0
                ? FMS_MEDIA +
                  `/uploads/vehicles/${item.vehicles[0].vehicle_image}`
                : "image/home/fleetcar1.png"
            }`}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default OurServices;
